import { IContentCreate, IContentDetails, IContentListSearch, IEditContentPayload, IGetContentList } from "../../../types/master/contentInterface";
import { ContentActionTypes, ContentActions } from "../../actionTypes/master/contentActionTypes";

export const createContent = (payload: IContentCreate): ContentActionTypes => ({
  type: ContentActions.CREATE_CONTENT,
  payload,
});

export const getContentList = (payload: IContentListSearch): ContentActionTypes => ({
  type: ContentActions.GET_CONTENT_LIST,
  payload,
});

export const setContentList = (branchList: Array<IGetContentList>) : ContentActionTypes => ({
  type: ContentActions.SET_CONTENT_LIST,
  payload: branchList
})

export const setContentListPageCount = (payload:number): ContentActionTypes => ({
  type: ContentActions.SET_CONTENT_LIST_PAGE_COUNT,
  payload
})

export const getContentDataById = (id: number): ContentActionTypes => ({
  type: ContentActions.GET_CONTENT_DATA_BY_ID,
  payload: id
})

export const setContentDataById = (payload: IContentDetails) => ({
  type: ContentActions.SET_CONTENT_DATA_BY_ID,
  payload
})

export const editContent = (payload: IEditContentPayload) => ({
  type: ContentActions.EDIT_CONTENT_DATA_BY_ID,
  payload,
});
